<template>
  <v-app style="min-height: 100vh">
    <v-main>
      <v-dialog v-model="disconnected" max-width="500px" persistent>
        <v-card>
          <v-progress-linear :indeterminate="connecting" color="secondary" />
          <v-card-title>Connect to Bluetooth LED Controller</v-card-title>
          <v-card-actions>
            <v-btn variant="text" color="error" @click="ignoreBluetooth">
              Ignore
            </v-btn>
            <v-spacer />
            <v-btn
              variant="contained-text"
              color="primary"
              @click="connectBluetooth"
              >Connect Bluetooth</v-btn
            ></v-card-actions
          >
        </v-card>
      </v-dialog>
      <v-content>
        <GeneratorList :BLE="BLEDevice" v-show="activeTab == 'Generators'" />
        <PaletteList :BLE="BLEDevice" v-show="activeTab == 'Palettes'" />
        <v-container fluid v-show="activeTab == 'Settings'">
          <v-row justify="center">
            <v-col cols="11" lg="6" class="pt-10">
              <v-slider
                messages="Brightness"
                v-model="brightness"
                min="0"
                max="1"
                step="0.01"
                @update:modelValue="setBright"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-content>
    </v-main>
    <NavBar @change="(tab) => (activeTab = tab)" />
  </v-app>
</template>


<script>
import GeneratorList from "./components/GeneratorList.vue";
import PaletteList from "./components/PaletteList.vue";
import NavBar from "./components/NavBar.vue";

var enc = new TextEncoder();

export default {
  name: "App",

  components: { GeneratorList, PaletteList, NavBar },
  created() {},
  data: () => ({
    activeTab: "Generators",
    disconnected: true,
    connecting: false,
    brightness: 1.0,
    BLEDevice: {
      device: {},
      server: {},
      service: {},
      genChar: {},
      palChar: {},
      brtChar: {},
      sendGenerator(genString) {
        console.log(enc.encode(genString).byteLength);
        this.genChar.writeValueWithResponse(enc.encode(genString));
      },
      sendPalette(palString) {
        console.log(this);
        this.palChar.writeValueWithResponse(enc.encode(palString));
      },
      sendBright(brightness) {
        console.log(this);
        this.brtChar.writeValueWithResponse(
          enc.encode("{brightness: " + brightness + "}")
        );
      },
    },
    //
  }),
  methods: {
    async connectBluetooth() {
      console.log("Requesting BLE Device");
      this.BLEDevice.device = await navigator.bluetooth.requestDevice({
        filters: [
          {
            name: "NimBLE-Arduino",
            services: ["c17378c5-b652-4e4b-9b53-45222f86e4d6"],
          },
        ],
      });

      this.connecting = true;

      this.BLEDevice.device.addEventListener("gattserverdisconnected", () => {
        this.disconnected = true;
      });

      console.log("Connecting to GATT server");
      this.BLEDevice.server = await this.BLEDevice.device.gatt.connect();

      console.log("Getting service");
      this.BLEDevice.service = await this.BLEDevice.server.getPrimaryService(
        "c17378c5-b652-4e4b-9b53-45222f86e4d6"
      );

      console.log("Getting Generator characteristic");
      this.BLEDevice.genChar = await this.BLEDevice.service.getCharacteristic(
        0x6eee
      );

      console.log("Getting Palette characteristic");
      this.BLEDevice.palChar = await this.BLEDevice.service.getCharacteristic(
        0x9a11
      );

      console.log(this.BLEDevice.palChar);

      console.log("Getting Brightness characteristic");
      this.BLEDevice.brtChar = await this.BLEDevice.service.getCharacteristic(
        0xb177
      );

      console.log(this.BLEDevice.brtChar);

      this.disconnected = false;
      this.connecting = false;
    },
    ignoreBluetooth() {
      if (
        confirm("You will not be able to control the lights, are you sure?")
      ) {
        this.disconnected = false;
      }
    },
    setBright(brightness) {
      this.BLEDevice.sendBright(brightness);
    },
  },
};
</script>